<div fxFlex fxLayout="column" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "PASSENGERS.managePassenger" | translate }}</span>
                    </div>
                    <div fxFlex style="text-align: right">
                        <button mat-mini-fab matTooltip="Add new passenger" (click)="onAddNewPassengerAction()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div fxFlex class="p-10">
        <mat-card appearance="outlined">
            <mat-card-content>
                <mat-form-field>
                    <mat-label>{{ "PASSENGERS.filter" | translate }}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input />
                </mat-form-field>
                <table mat-table [dataSource]="passengersList">
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.no" | translate }}</th>
                        <td mat-cell *matCellDef="let index = index">{{ index + 1 }}</td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.name" | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.firstName }} {{ element.lastName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="dateOfBirth">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.dateOfBirth" | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.dateOfBirth | date: "dd-MM-yyyy" }}</td>
                    </ng-container>
                    <ng-container matColumnDef="gender">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.gender" | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.gender }}</td>
                    </ng-container>
                    <ng-container matColumnDef="idCardNumber">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.idCardNumber" | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.idCardNumber }}</td>
                    </ng-container>
                    <ng-container matColumnDef="nationality">
                        <th mat-header-cell *matHeaderCellDef>{{ "PASSENGERS.nationality" | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.nationalityId | nationality: "name" }}</td>
                    </ng-container>
                    <ng-container matColumnDef="idCardImageName">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center">{{ "PASSENGERS.idCardPicture" | translate }}</th>
                        <td mat-cell *matCellDef="let element" style="text-align: center">
                            @if (element.imageCount > 0) {
                                <button mat-icon-button [matTooltip]="'PASSENGERS.showIdCardPicture' | translate" (click)="openIdCardImageDialog(element.id)">
                                    <mat-icon class="mr-5" style="color: green">check</mat-icon>
                                </button>
                            } @else {
                                <mat-icon class="mr-5" style="color: red">close</mat-icon>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right">Actions</th>
                        <td mat-cell *matCellDef="let element" style="text-align: right">
                            <button mat-icon-button [matTooltip]="'PASSENGERS.delete' | translate" (click)="onPassengerDeleteAction(element.id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button [matTooltip]="'PASSENGERS.edit' | translate" (click)="onPassengerEditAction(element.id)">
                                <mat-icon>create</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            </mat-card-content>
        </mat-card>
    </div>
</div>
